/**
 * @generated SignedSource<<e543e2a78e65cdf52b605f2a6ad897bd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues$data = {
  readonly error?: {
    readonly displayMessage: string | null | undefined;
    readonly errorType: string | null | undefined;
    readonly statusCode: number | null | undefined;
  } | null | undefined;
  readonly taskProgress?: {
    readonly task: {
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues";
};
export type exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues$key = {
  readonly " $data"?: exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues$data;
  readonly " $fragmentSpreads": FragmentRefs<"exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraIssueExportTaskProgress",
          "kind": "LinkedField",
          "name": "taskProgress",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraIssueExportTask",
              "kind": "LinkedField",
              "name": "task",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "id"
                }
              ]
            }
          ]
        },
        {
          "concreteType": "JiraIssueExportError",
          "kind": "LinkedField",
          "name": "error",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "displayMessage"
            },
            {
              "kind": "ScalarField",
              "name": "errorType"
            },
            {
              "kind": "ScalarField",
              "name": "statusCode"
            }
          ]
        }
      ],
      "type": "JiraIssueExportTaskTerminated"
    }
  ],
  "type": "JiraIssueExportEvent",
  "abstractKey": "__isJiraIssueExportEvent"
};

(node as any).hash = "187b120d7de34a9598bbe1dc5f854515";

export default node;
